module.exports = __webpack_public_path__ + "img/socialMediaTwitterGreen.c7bc63b5.svg";